import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from '../services/shared.service';
import { TeamService } from './team.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-team-selection',
  templateUrl: './team-selection.component.html',
  styleUrls: ['./team-selection.component.scss']
})
export class TeamSelectionComponent implements OnInit {

  organizations = [];
  selectedOrganization = {};
  bgTextColor = "#000000";
  bgColor = "#fff"
  activeOrgs = [];  
  constructor(
    private _router: Router,
    private _teamService: TeamService,
    private _sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this._sharedService.getUserDetails().subscribe((response) => {
      if(response["success"]) {
        localStorage.setItem('email', response['user']['email']);
        localStorage.setItem('organization', response['user']['organization']);
        localStorage.setItem('role', response['user']['role']);
        localStorage.setItem('username', response['user']['username']);
        localStorage.setItem('firstName', response['user']['firstName']);
        localStorage.setItem('lastName', response['user']['lastName']);
        localStorage.setItem('organizationLogo', response['user']['organizationLogo']);
        if(response['user']['address'] && response['user']['address']['state']) {
          localStorage.setItem('organizationAddress', response['user']['address']['state']);
        }
        localStorage.setItem('organizationName', response['user']['organizationName']);
        localStorage.setItem('organizationCode', response['user']['organizationCode']);
        localStorage.setItem('userId', response['user']['userId']);
        localStorage.setItem('tooltip_enabled', response['user']['tooltip_enabled']);
        
        if(response['user'] && response['user']['timezone']) {
          localStorage.setItem('timezone', response['user']['timezone'])
        }
               

        if(response['user'] && response['user']['tooltip_enabled'] == undefined) {
          localStorage.setItem('tooltip_enabled', 'true')
        }
        localStorage.setItem('organizations', JSON.stringify(response['user']['organizations']));
        
        const teams = localStorage.getItem('organizations');
        const organizationId = localStorage.getItem('organization');
        this.selectedOrganization['_id'] = organizationId;
        if(teams) {
          this.organizations = JSON.parse(teams);
        } else {
          this.organizations = [];
        }

        if (response['user']['theme'] && response['user']['theme']['bg_color'])localStorage.setItem('bgColor', response['user']['theme']['bg_color']);
        if (response['user']['theme'] && response['user']['theme']['bg_text_color'])localStorage.setItem('bgTextColor', response['user']['theme']['bg_text_color']);
    
        let bgTextColor = localStorage.getItem('bgTextColor');
        if (bgTextColor && bgTextColor.length > 0) {
          bgTextColor = bgTextColor.substring(1);
        }
        if (localStorage.getItem('bgColor')) {
          this.bgColor = localStorage.getItem("bgColor")
        };

        if (this.organizations && this.organizations.length > 1) {
          let active_orgs = _.filter(this.organizations, (org) => {
            return org.team_status == true;
          })
          this.activeOrgs = active_orgs;

          if(active_orgs && active_orgs.length == 1) {
            this.selectedOrganization = active_orgs[0];
            this.updateTokensById();
          }
        } else if (this.organizations && this.organizations.length == 1) {
          this.selectedOrganization = this.organizations[0];
          this.updateTokensById();
        }
        localStorage.setItem('enable_subscription', response['enable_subscription'] || false);
      }
    })
  }

  updateTokensById() {
    const localOrgId = localStorage.getItem("organization");
    if(this.selectedOrganization) {
      if(localOrgId != this.selectedOrganization['_id']) {
        localStorage.setItem('organization', this.selectedOrganization['_id'])
        localStorage.setItem('organizationLogo', this.selectedOrganization['logo']);
        if(this.selectedOrganization['address'] && this.selectedOrganization['address']['state']) {
          localStorage.setItem('organizationAddress', this.selectedOrganization['address']['state']);
        } else {
          localStorage.removeItem('organizationAddress');
        }
        localStorage.setItem('organizationName', this.selectedOrganization['name']);
        localStorage.setItem('organizationCode', this.selectedOrganization['code']);
        localStorage.setItem('tooltip_enabled', this.selectedOrganization['tooltip_enabled']) 

        if(this.selectedOrganization['theme'] && this.selectedOrganization['theme']['bg_color']) {
          localStorage.setItem('bgColor', this.selectedOrganization['theme']['bg_color'])
        }

        if(this.selectedOrganization['theme'] && this.selectedOrganization['theme']['bg_text_color']) {
          localStorage.setItem('bgTextColor', this.selectedOrganization['theme']['bg_text_color'])
        }

        this._teamService.updateTokensById(this.selectedOrganization['_id']).subscribe((response: any) => {
          localStorage.setItem('enable_subscription', response['enable_subscription'] || false);
          let url = this._router.serializeUrl(this._router.createUrlTree([localStorage.getItem('organizationCode') + '/dashboard']));
          window.open(url, "_self");
        })
      } else {
          let url = this._router.serializeUrl(this._router.createUrlTree([localStorage.getItem('organizationCode') + '/dashboard']));
          window.open(url, "_self");
      }
    }
  }

}
